"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestRetry = void 0;
class RequestRetry {
    constructor(config) {
        this.config = { ...RequestRetry.defaultRetryConfig, ...config };
        this.maxCount = this.config.maxCount;
    }
    // exponential backoff with full jitter randomization to reduce contention
    computeRetryTime(count) {
        return this.randomBetween(this.config.minDelay, Math.min(this.config.capDelay, this.config.baseDelay * 2 ** count));
    }
    randomBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    retryable(error) {
        const isRetryableRequestError = !error.response && error.code && this.config.retryRequestCodes?.includes(error.code);
        const isRetryableResponseError = (error.response && this.config.retryResponseCodes?.includes(error.response.status)) ||
            error.response?.data.message?.includes('ThrottlingException');
        return isRetryableRequestError || isRetryableResponseError;
    }
}
exports.RequestRetry = RequestRetry;
RequestRetry.retryRequestCodes = [
    'ESOCKETTIMEDOUT',
    'ETIMEDOUT',
    'ECONNRESET',
    'ECONNREFUSED',
    'EAI_AGAIN',
];
RequestRetry.retryResponseCodes = [429, 500, 502, 503, 504];
RequestRetry.defaultRetryConfig = {
    retryRequestCodes: RequestRetry.retryRequestCodes,
    retryResponseCodes: RequestRetry.retryResponseCodes,
    exclusionList: [],
    maxCount: 3,
    minDelay: 0,
    baseDelay: 100,
    capDelay: 10000, // 10 s
};
//# sourceMappingURL=RequestRetry.js.map